(function() {
  'use strict';

  var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function addToCart(variantId, button) {
    if (button.classList.contains('is-added') || button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Add to cart failed');
      return resp.json();
    })
    .then(function() {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.innerHTML = checkIcon;

      var card = button.closest('.upsell-addons__card, .stepper-upsell__card');
      if (card) card.classList.add('is-added');

      // Dispatch cart:update event so cart drawer refreshes its items
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'upsell-addons', data: {} }
      }));
    })
    .catch(function(err) {
      console.error('Upsell add to cart error:', err);
      button.classList.remove('is-loading');
    });
  }

  // Delegate clicks for product page upsell buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.upsell-addons__add');
    if (!btn) return;
    var card = btn.closest('.upsell-addons__card');
    if (!card) return;
    var variantId = parseInt(card.dataset.variantId, 10);
    if (variantId) addToCart(variantId, btn);
  });

  // Delegate clicks for stepper upsell buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.stepper-upsell__card-add');
    if (!btn) return;
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (variantId) addToCart(variantId, btn);
  });

})();
